"use client";

import {Partial} from "@/components/partial/partial";
import {useNeoContext} from "@/context/neo/neo.context";
import {PartialPageConfig} from "@/libs/config/navigation.config";
import {canReadModule} from "@/libs/helper";
import type {PropsWithChildren} from "react";

type ModuleReadGuardProps = PropsWithChildren<{
  moduleCode: string;
  fallbackUrl?: string;
  fallbackText?: string;
}>;

export const ModuleReadGuard = ({
  moduleCode,
  fallbackUrl = process.env.AUTH_URL,
  fallbackText = "Back to home",
  children
}: ModuleReadGuardProps) => {
  const {roleAccess} = useNeoContext();

  if (!canReadModule(roleAccess, moduleCode)) {
    const config = PartialPageConfig.accessDenied;

    return (
      <Partial
        head={config.head}
        message={config.message}
        imageUrl={config.imageUrl}
        btnText={fallbackText}
        btnUrl={fallbackUrl}
      />
    );
  }

  return <>{children}</>;
};
